import { useEffect } from 'react';

import { QUESTIONNAIRE_CODE } from 'lib/constants';
import { useQuestionnaireStore } from 'store/questionnaire';
import QuestionnaireWrapper from './components/QuestionnaireWrapper';
import FitnessLevel from './FitnessLevel';
import AlcoholConsumption from './AlcoholConsumption';
import Smoking from './Smoking';
import FamilyMedicalCondition from './FamilyMedicalCondition';
import BodyComplexion from './BodyComplexion';
import EatingHabits from './EatingHabits';
import MedicalCondition from './MedicalCondition';

export default function RiskCheckerQuestionnairePage() {
  const questionData = useQuestionnaireStore((store) => store.questionData);
  const setQuestionData = useQuestionnaireStore(
    (store) => store.setQuestionData
  );

  useEffect(() => {
    return () => {
      setQuestionData(undefined);
    };
  }, []);

  if (!questionData) {
    return null;
  }

  const renderQuestion = () => {
    switch (questionData.code) {
      case QUESTIONNAIRE_CODE.BODY_TYPE:
        return <BodyComplexion />;
      case QUESTIONNAIRE_CODE.FITNESS_LEVEL:
        return <FitnessLevel />;
      case QUESTIONNAIRE_CODE.EATING_HABITS:
        return <EatingHabits />;
      case QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION:
        return <AlcoholConsumption />;
      case QUESTIONNAIRE_CODE.SMOKING:
        return <Smoking />;
      case QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS:
        return <MedicalCondition />;
      case QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS:
        return <FamilyMedicalCondition />;
      default:
        return null;
    }
  };

  return <QuestionnaireWrapper>{renderQuestion()}</QuestionnaireWrapper>;
}
